module.exports = __webpack_public_path__ + "img/wechat_hover.2adedce0.png";